import { APIDelete, APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

type TGetNewsLetterPosts = {
  id?: number;
  limit?: number;
  offset?: number;
  search?: string;
};

type TGetNewsLetterSubscribers = {
  id?: number;
  limit?: number;
  offset?: number;
  search?: string;
};

type TPostNewsLetterPost = {
    title: string;
    content: string;
  };

  interface IPutNewsLetterPost extends TPostNewsLetterPost {
   id: number;
  };

export type TNewsLetterPost = {
    id: number;
    facility_id: number;
    published_by_id: number;
    title: string;
    content: string;
    status: "draft" | "published";
    published_at: string;
    published_by_name?: string;
};

export type TNewsLetterSubscriber = {
  id: number;
  facility_id: number;
  customer_id: number;
  subscribed: boolean;
  user_email: string;
  user_first_name: string;
  user_last_name: string;
  customer_type_title: string;
  customer_type_subtitle: string;
};

export async function GetNewsLetterPosts(params: TGetNewsLetterPosts, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<Array<TNewsLetterPost>>(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter"), params, useGlobalLoader, token);
}

export async function PostNewsLetterPost(params: TPostNewsLetterPost, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter"), params, useGlobalLoader);
}

export async function PostDuplicateNewsLetterPost(params: {id: number}, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter/duplicate"), params, useGlobalLoader);
}

export async function PutNewsLetterPost(params: IPutNewsLetterPost, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter"), params, useGlobalLoader);
}

export async function PutPublishNewsLetterPost(params: {id: number}, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter/publish"), params, useGlobalLoader);
}

export async function DeleteNewsLetterPost(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter"), params, useGlobalLoader);
}

export async function GetNewsLetterSubscribers(params: TGetNewsLetterSubscribers, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<Array<TNewsLetterSubscriber>>(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter/subscriber"), params, useGlobalLoader, token);
}

export async function PutExportNewsletterSubscribers(useGlobalLoader: boolean, token?: CancelToken) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/news-letter/subscriber/export"), null, useGlobalLoader, token);
}